import React from 'react';
import * as Sentry from '@sentry/browser';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { createTheme, ThemeProvider } from 'chaser-components';
import { PersistGate } from 'redux-persist/integration/react';
import { Router } from 'react-router';
import store, { history, persistor } from './store';
import App from './App';
import { BrowserTracing } from '@sentry/tracing';

import 'chaser-components/dist/index.css';
import 'sanitize.css/sanitize.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.scss';

const target = document.querySelector('#root');
const theme = createTheme();

if (process.env.REACT_APP_ENV !== 'local') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new BrowserTracing()],
    environment:
      process.env.REACT_APP_ENV === 'next'
        ? 'production'
        : process.env.REACT_APP_ENV,
  });
}

render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ThemeProvider theme={theme}>
        <Router history={history}>
          <App />
        </Router>
      </ThemeProvider>
    </PersistGate>
  </Provider>,
  target,
);
